import { render, staticRenderFns } from "./CompanyInfoWrapper.vue?vue&type=template&id=0236b34a&scoped=true&"
import script from "./CompanyInfoWrapper.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyInfoWrapper.vue?vue&type=style&index=0&id=0236b34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236b34a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0236b34a')) {
      api.createRecord('0236b34a', component.options)
    } else {
      api.reload('0236b34a', component.options)
    }
    module.hot.accept("./CompanyInfoWrapper.vue?vue&type=template&id=0236b34a&scoped=true&", function () {
      api.rerender('0236b34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoWrapper.vue"
export default component.exports